import React from "react";
import { I, T } from "services/lang/LanguageService";

const DevSandbox = () => {
  return (
    <div>
      <li>{T("greeting", { name: "Vardenis Pavardenis" })}</li>
      <li>{T("mango.ango", { name: "Vardenis Pavardenis" })}</li>
      <li>{T("word.from")}</li>
      <li>{T("word.to")}</li>
      <li>{T("side-menu.home")}</li>

      <li>{I("Hello {greeting} and {side-menu.home} and {a.test-key}")}</li>
      <li>{I("This is interpolated string {_company.custom.key1}")}</li>
    </div>
  );
};

export default DevSandbox;
